import React from 'react';
import { MoonIcon } from '@heroicons/react/16/solid';
import { Switch } from '../common/Catalyst/switch';
import { useTheme } from '../common/Custom/ThemeProvider';

/**
 * Light / dark as a switch, the sidebar footer's first row — in the
 * signed-in sidebar and on the sign-in page's alike, so the two cannot
 * drift. Labelled by aria-label, not an id: on a phone the sidebar
 * renders twice.
 */
export const DarkModeSwitch: React.FC = () => {
  const { isDarkMode, toggleDarkMode } = useTheme();

  return (
    <div className="flex items-center justify-between gap-2 px-2 py-1.5">
      <span className="flex items-center gap-2 text-[13px] text-canvas-fg">
        <MoonIcon className="h-4 w-4 fill-canvas-fg" aria-hidden />
        Dark mode
      </span>
      <Switch
        color="sky"
        checked={isDarkMode}
        onChange={() => toggleDarkMode()}
        aria-label="Dark mode"
      />
    </div>
  );
};
